import * as styled from './ChatListPane.styled'
import { useNavigate, useParams } from "react-router-dom";

export function ChatListPane({ chats }) {
  const navigate = useNavigate();
  const { studentId: activeId } = useParams();

  return (
    <styled.Sidebar>
      <styled.SidebarHeader>Чаты с учениками</styled.SidebarHeader>
      <styled.ChatList>
        {chats.map((c) => (
          <styled.ChatListItem
            key={c.studentId}
            active={c.studentId === activeId}
            onClick={() => navigate(`/manager/chat/${c._id}`)}
          >
            <div>
              <strong>{c.name}-{`(${c.studentId})`}</strong>
              {c.unread && <styled.UnreadDot />}
            </div>
          </styled.ChatListItem>
        ))}
      </styled.ChatList>
    </styled.Sidebar>
  );
}